import React from 'react';
import { ClickableTile } from 'carbon-components-react';
import { ArrowRight16 } from '@carbon/icons-react';
import messages from '../../../locales/messages';
import Cta from '../../Molecules/Cta/Cta';
import { getMessage } from 'src/common/hooks/widgets/useLang';
import './Welcome.scss';
import C4DVideoPlayerContainer from '@carbon/ibmdotcom-web-components/es/components-react/video-player/video-player-container';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import * as VideosIDs from '../../../constants/default';
import { segmentsTracking } from 'src/common/lib/tracker';

type WelcomeProps = {
  handleLaunchModal: () => void;
  modal2: boolean;
  setModal2: React.Dispatch<React.SetStateAction<boolean>>;
  modalBtnLangText: string;
  toggleCountry: boolean;
  localExist: boolean;
  flag: boolean;
};

const Welcome = ({
  handleLaunchModal,
  setModal2,
  modalBtnLangText,
  toggleCountry,
  localExist,
  flag,
}: WelcomeProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);

  return (
    <section className="welcome">
      <div className="bx--row">
        <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4 videoContainer">
          <C4DVideoPlayerContainer
            aspectRatio="16x9"
            playing-mode="inline"
            hide-caption={true}
            video-description=""
            videoId={VideosIDs.videoId_welcome}
            onClick={() => {
              segmentsTracking('CTA Clicked', {
                pageTitle: 'AI Solutions Advisor',
                object: 'AI Solutions Advisor page',
                resultValue: 'CTA clicked',
                CTA: 'Introduction video launched',
                location: 'Main widget page',
                action: `Launched media video`,
                field: '',
              });
            }}
          />
        </div>
        <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="welcome_heading">
                {useTranslation('welcome_title')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="welcome_subheadign">
                {useTranslation('welcome_subtitle')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="welcome_paragraph">
                {useTranslation('welcome_paragraph')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4">
              {flag && localExist && toggleCountry && (
                <Cta
                  value={`${getMessage(
                    messages.welcome_accessPageCapitalized,
                  )} ${modalBtnLangText}`}
                  handleClick={() => setModal2(true)}
                  kind="tertiary"
                  iconType="arrow"
                  classes="welcome_CTA"
                />
              )}
            </div>
            <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4">
              <ClickableTile
                id="clickabel-tile-01"
                className="welcome_tile"
                role="button"
                onClick={() => {
                  handleLaunchModal();
                }}
              >
                <div className="bx--row">
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                    <p className="welcome_tile_text">
                      {useTranslation('welcome_CTA01')}
                    </p>
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                    <ArrowRight16 className="welcome_tile_arrow" />
                  </div>
                </div>
              </ClickableTile>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
